import { assertNever } from '@kofno/piper';
import { just, Maybe, nothing } from 'maybeasy';
import { action, computed, makeObservable, observable } from 'mobx';
import { Freebusy } from '../components/Freebusy/Types';
import { error } from '../ErrorHandling';
import { FreebusySettings } from '../FreebusyStore';
import { errorAlert, FlashAlert } from '../Notifications/Types';
import { TPlainTextKey } from '../Translations';
import { initializing, loading, ready, State, submitted, waiting } from './Types';

class FreeBusyTestStore {
  @observable
  state: State;

  constructor() {
    makeObservable(this);

    this.state = waiting();
  }

  @action
  initializing = (freebusy: Freebusy, freebusySettings: FreebusySettings) => {
    switch (this.state.kind) {
      case 'loading':
        this.state = initializing(freebusy, freebusySettings, this.state);
        break;
      case 'waiting':
      case 'initializing':
      case 'ready':
      case 'submitted':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  loading = (freebusySettings: FreebusySettings) => {
    switch (this.state.kind) {
      case 'waiting':
        this.state = loading(freebusySettings);
        break;
      case 'loading':
      case 'initializing':
      case 'ready':
      case 'submitted':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  submitted = () => {
    switch (this.state.kind) {
      case 'waiting':
      case 'loading':
      case 'initializing':
      case 'submitted':
      case 'error':
        break;
      case 'ready':
        this.state = submitted();
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  ready = () => {
    switch (this.state.kind) {
      case 'waiting':
      case 'loading':
      case 'ready':
      case 'submitted':
      case 'error':
        break;
      case 'initializing':
        this.state = ready();
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (msg: TPlainTextKey) => {
    this.state = error(msg);
  };

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'error':
        return just(this.state).map(errorAlert);
      case 'ready':
      case 'submitted':
      case 'initializing':
      case 'waiting':
      case 'loading':
        return nothing();
    }
  }
}

export default FreeBusyTestStore;
